export const COLORS = {
  primary: { light: '#80C0E6', medium: '#0082CD', dark: '#0F1653' },
  text: { hint: '#696B7B', default: '#0F1653' },
  error: '#E23352',
}
